import { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import api from "../services/api";
import { useAuth } from "../AuthContext";
import { EMPTY_COUNTS, parseBadgeCounts } from "./badgeCounts";

const BadgeCountsContext = createContext({});

export function BadgeCountsProvider({ children }) {
  const { user } = useAuth();
  const [counts, setCounts] = useState(EMPTY_COUNTS);
  // Only the newest request may set counts, so a slow older poll can't undo a newer refresh.
  const latest = useRef(0);

  const fetchCounts = useCallback(async () => {
    const id = ++latest.current;
    try {
      const res = await api.get("/admin/badge-counts");
      if (id === latest.current) setCounts(parseBadgeCounts(res.data));
    } catch (err) {
      console.error("Badge counts error:", err?.response?.status, err?.message);
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    fetchCounts();
    const interval = setInterval(fetchCounts, 60000); // refresh every 60s
    return () => clearInterval(interval);
  }, [user, fetchCounts]);

  return (
    <BadgeCountsContext.Provider value={{ counts, refreshCounts: fetchCounts }}>
      {children}
    </BadgeCountsContext.Provider>
  );
}

export function useBadgeCounts() {
  return useContext(BadgeCountsContext);
}
